import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";

export async function deleteUser(userId: string): Promise<void> {
  await apiClient.delete(apiPaths.users.delete(userId));
}
